import React from 'react';
import { Input } from './input';

/**
 * NumberInput — a friendlier controlled numeric input.
 * - Shows blank when value is 0/null (so users don't have to delete a leading zero).
 * - Accepts empty state and reports 0 to the parent when cleared.
 * - Ignores leading zeros as the user types (types "2000", not "02000").
 */
export const NumberInput = React.forwardRef(({ value, onChange, allowDecimal = true, className = '', ...props }, ref) => {
  const display = value === 0 || value === null || value === undefined || value === '' ? '' : String(value);

  const handleChange = (e) => {
    let v = e.target.value;
    // Allow empty
    if (v === '') { onChange(0); return; }
    // Strip disallowed characters
    if (!allowDecimal) v = v.replace(/[^0-9]/g, '');
    else v = v.replace(/[^0-9.]/g, '');
    // Only one dot
    const firstDot = v.indexOf('.');
    if (firstDot !== -1) v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, '');
    // Strip leading zeros (but keep "0.xxx" and empty)
    if (/^0\d/.test(v)) v = v.replace(/^0+/, '') || '0';
    onChange(v === '' || v === '.' ? 0 : Number(v));
  };

  return (
    <Input
      ref={ref}
      type="text"
      inputMode={allowDecimal ? 'decimal' : 'numeric'}
      value={display}
      onChange={handleChange}
      className={className}
      {...props}
    />
  );
});

NumberInput.displayName = 'NumberInput';

export default NumberInput;
